import React from 'react';
import { useNavigate } from 'react-router-dom';

import * as ChannelService from "@channel.io/channel-web-sdk-loader";

ChannelService.loadScript();
ChannelService.boot({
  pluginKey: "15042e62-28ff-4996-85d6-badb1a077e70", // fill your plugin key
});

function Footer() {
  return (
    <footer class="bg-gray-900 py-16 text-white">
      <div class="container mx-auto px-6">
        <div class="grid grid-cols-1 gap-6 md:grid-cols-3">
          <div>
            <div class="mb-6 flex items-center space-x-2">
              <span class="text-xl font-bold">주식회사 레이어블</span>
            </div>
            <ul class="space-y-2">
              <li class="text-gray-400">모든 창작자들의 꿈과 이야기를 세상에 펼치도록</li>

              <li class="text-gray-400">문의: 1877-3218</li>
              <li class="text-gray-400">이메일: contact@layable.kr</li>
            </ul>
          </div>
          <div>
            <ul class="space-y-2">
              <h4 class="mb-4 hidden text-lg font-bold lg:block">‭ ‭ ‭ ‭</h4>
              <li class="text-gray-400">대표이사: 장범준</li>
              <li class="text-gray-400">
                경기도 수원시 영통구 광교로 145 A동 1323호
                <br />
                (차세대융합기술연구원)
              </li>
              <li class="text-gray-400">사업자등록번호: 772-87-03404</li>
              <li class="text-gray-400">통신판매업신고: 제 2024-수원영통-1830호</li>
            </ul>
          </div>
          <div>
            <h4 class="mb-4 text-lg font-bold">바로가기</h4>
            <ul class="space-y-2 text-gray-400">
              <li>
                <a href="//layable.kr" class="text-gray-400 hover:text-white">
                  홈페이지
                </a>
              </li>
              <li>
                <a onClick={() => ChannelService.openChat()} class="text-gray-400 cursor-pointer hover:text-white">
                  1:1 문의
                </a>
              </li>
              <li>
                <a href="//shop.layable.kr" class="text-gray-400 hover:text-white">
                  Shop
                </a>
                &nbsp;/&nbsp;
                <a href="//3dmake.layable.kr" class="text-gray-400 hover:text-white">
                  3D 제작대행
                </a>
              </li>
              <li>
                <a href="//layable.kr/#/tos" class="text-gray-400 hover:text-white">
                  이용약관
                </a>
                &nbsp;/&nbsp;
                <a href="//layable.kr/#/privacy" class="text-gray-400 hover:text-white">
                  개인정보처리방침
                </a>
              </li>
              {/* <li>
                  <a href="#" class="text-gray-400 hover:text-white">
                    환불규정
                  </a>
                </li> */}
            </ul>
          </div>
        </div>
        <div class="mt-12 border-t border-gray-800 pt-8 text-center text-gray-400">
          <p>© 2025 Layable. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}




// function Footer() {
//   const navigate = useNavigate();

//   return (
//     <footer className="bg-gray-900 py-16 text-white">
//       <div className="container mx-auto px-6">
//         <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
//           {/* 회사 정보 */}
//           <div>
//             <h3 className="text-lg font-bold mb-4">주식회사 레이어블</h3>
//             <p className="text-gray-400 mb-2">모든 창작자들의 꿈과 이야기를 세상에 펼치도록</p>
//             <p className="text-gray-400">문의: 1877-3218</p>
//             <p className="text-gray-400">이메일: contact@layable.kr</p>
//           </div>

//           {/* 사업자 정보 */}
//           <div className="text-gray-400">
//             <p className="mb-1">대표이사: 장범준</p>
//             <p className="mb-1">경기도 수원시 영통구 광교로 145 A동 1323호</p>
//             <p className="mb-1">(차세대융합기술연구원)</p>
//             <p className="mb-1">사업자등록번호: 772-87-03404</p>
//             <p>통신판매업신고: 제 2024-수원영통-1830호</p>
//           </div>

//           {/* 바로가기 */}
//           <div>
//             <h3 className="text-lg font-bold mb-4">바로가기</h3>
//             <ul className="space-y-2">
//               <li>
//                 <button
//                   onClick={() => navigate('/products')}
//                   className="text-gray-400 hover:text-teal-400 transition-colors"
//                 >
//                   상품 목록
//                 </button>
//               </li>
//               <li>
//                 <button
//                   onClick={() => navigate('/cart')}
//                   className="text-gray-400 hover:text-teal-400 transition-colors"
//                 >
//                   장바구니
//                 </button>
//               </li>
//               <li>
//                 <button
//                   onClick={() => navigate('/orders')}
//                   className="text-gray-400 hover:text-teal-400 transition-colors"
//                 >
//                   주문내역
//                 </button>
//               </li>
//               <li>
//                 <a
//                   href="/tos"
//                   className="text-gray-400 hover:text-teal-400 transition-colors"
//                 >
//                   이용약관
//                 </a>
//               </li>
//               <li>
//                 <a
//                   href="/privacy"
//                   className="text-gray-400 hover:text-teal-400 transition-colors"
//                 >
//                   개인정보처리방침
//                 </a>
//               </li>
//             </ul>
//           </div>
//         </div>

//         <div className="mt-12 border-t border-gray-800 pt-8 text-center text-gray-400">
//           © 2025 Layable. All rights reserved.
//         </div>
//       </div>
//     </footer>
//   );
// }

export default Footer;
